import React from 'react';

import { Button, Icon, Text, Tooltip } from '@ui-library';
import { IconName } from '@ui-library/Icon/Icon.type';

interface StackInfoProps {
  /** What it tells about, for its accessible name: "About <label>". */
  label: string;
  /** What it includes, a line each, from GET /projects/stacks. */
  lines: string[];
}

/** The info icon after a tech stack or a Custom option, showing what it includes.
 *  It sits outside the option's label, so pressing it neither chooses the option
 *  nor submits the form. Its text opens below it and stays on screen wherever the
 *  icon is, in either column of Custom's groups and on a narrow screen: it moves
 *  sideways, and its lines wrap where the screen is narrower than they are. */
export const StackInfo: React.FC<StackInfoProps> = ({ label, lines }) => (
  <Tooltip
    position="bottom-right"
    openOnClickAndFocus
    keepOnScreen
    content={
      <div className="flex flex-col gap-bg-v2-xs">
        {lines.map((line, index) => (
          <Text key={index} variant="text-xs" color="secondary">{line}</Text>
        ))}
      </div>
    }
  >
    <Button
      type="button"
      variant="ghost"
      size="very-small"
      ariaLabel={`About ${label}`}
      className="!p-bg-v2-none !h-auto"
      label={<Icon name={IconName.InfoCircle} size="xs" variant="secondary" />}
    />
  </Tooltip>
);
